import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const propTypes = {
    /** Label's contents, usually text */
    children: PropTypes.node.isRequired,

    /** Adds the required asterisk */
    isRequired: PropTypes.bool,

    /** Accepts a custom className that will be merged in with other classes */
    className: PropTypes.string,

    /** If true, label will not be read by screen readers */
    isAriaHidden: PropTypes.bool
};


const defaultProps = {
    className: null,
    isRequired: false,
    isAriaHidden: true
};

export default function VisualOnlyLabel(props) {
    const { children, className, isRequired, isAriaHidden, ...rest } = props;

    return (
        <div
            data-component="VisualOnlyLabel"
            aria-hidden={isAriaHidden ? "true" : null}
            className={cx('sarsa-label', className)}
            {...rest}>
            {children}
            {isRequired && (
                <abbr className="sarsa-label-required-indicator">
                    <span aria-hidden="true">*</span>
                    <span className="rec-sr-only"> (Required) </span>
                </abbr>
            )}
        </div>
    );
}

VisualOnlyLabel.propTypes = propTypes;
VisualOnlyLabel.defaultProps = defaultProps;